
// Example: "Feb 21 @ 12:00 PM"
export const getDateAtTimeFormat = (date: Date) => {
const options: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};
return date.toLocaleString('en-US', options).replace(',', ' @');
}

export const formatSmartDate = (date: Date, separator: string = '') => {
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();

  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(now.getDate() - 7);

  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).toLowerCase();

  if (isToday) {
    return timePart; // e.g., "3:00 pm"
  }

  if (date > sevenDaysAgo) {
    const weekday = date.toLocaleDateString('en-US', {
      weekday: 'short',
    });
    return `${weekday} ${separator} ${timePart}`; // e.g., "Tue @ 3:00 pm"
  }

  const datePart = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
  return `${datePart}${Boolean(separator) ? ` ${separator} ` : ` `}${timePart}`; // e.g., "Apr 12 @ 3:00 pm"
};